import { render, staticRenderFns } from "./LeavesCalendar.vue?vue&type=template&id=4a9ca241"
import script from "./LeavesCalendar.vue?vue&type=script&lang=js"
export * from "./LeavesCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports